import { hasWindow } from "@omni/utils/dom.utils";
import { isEnum } from "@omni/utils/enum.utils";
import { isDefined } from "@omni/utils/helper.utils";

import { CookieSetEvent } from "@/services/windowEvents/events/cookieSet.event";

export enum Cookie {
    ECornerId = "ECORNER_ID",
    ECornerStoreId = "ECORNER_STORE_ID",
    ECornerTerminalId = "ECORNER_TERMINAL_ID",
    Language = "HB_LANGUAGE",
    ReviewsFeedback = "HB_REVIEWS_FEEDBACK",
    Ga = "_ga"
}

export const get = async (name: Cookie) => {
    if (!hasWindow()) return;

    return window.cookieStore.get(name).then((cookie) => {
        return cookie?.value;
    });
};

export const set = async (name: Cookie, value: string, days?: number) => {
    if (!hasWindow()) return;

    return window.cookieStore.set({
        name: name,
        value: value,
        expires: days ? Date.now() + days * 24 * 60 * 60 * 1000 : undefined,
        path: "/",
        domain: `.${LIB_NAME}.be`
    });
};

export const remove = async (name: Cookie) => {
    if (!hasWindow()) return;

    return window.cookieStore.delete(name);
};

export const setLanguageCookie = (languageCode: string) => {
    return set(Cookie.Language, languageCode, 30);
};

const _handleOnCookieChange = (event: CookieChangeEvent) => {
    event.changed.forEach((cookie) => {
        if (!isEnum(Cookie, cookie.name)) return;
        if (!isDefined(cookie.value)) return;

        window.dispatchEvent(new CookieSetEvent(cookie.name, cookie.value));
    });
};

(() => {
    if (!hasWindow()) return;

    window.cookieStore.addEventListener("change", _handleOnCookieChange);
})();
